import { api } from "services/axios/api";
import { getErrorsByApi } from "shared/helpers/getErrorsByApi";

export interface INotificacao {
  id: number;
  tipoEvento: string;
  destinatarioEmail: string;
  nomeDestinatario: string;
  assunto: string;
  mensagem: string;
  status: string; // "Enviado", "Falhou", "Pendente"
  dataEnvio?: Date;
  idSolicitacaoTipologia?: number;
  idSerial?: number;
  inquilinoId?: string;
}

export interface IListarNotificacoesParams {
  idSolicitacaoTipologia?: number;
  idSerial?: number;
  inquilinoId?: string;
  tipoEvento?: string;
  dataInicio?: string; // yyyy-MM-dd
  dataFim?: string; // yyyy-MM-dd
}

export const listarNotificacoes = async (params?: IListarNotificacoesParams): Promise<INotificacao[]> => {
  try {
    const { data } = await api.get<INotificacao[]>("/Notificacao/ListarNotificacoes", {
      params,
    });
    return data || [];
  } catch (error: any) {
    getErrorsByApi(error, "Erro ao listar notificações");
    console.error("[API ERROR]", error?.response?.status, error);
    return [];
  }
};

export interface IEnviarNotificacaoRequest {
  tipoEvento: string;
  destinatarioEmail: string;
  nomeDestinatario: string;
  assunto: string;
  mensagem: string;
  idSolicitacaoTipologia?: number;
  idSerial?: number;
  inquilinoId?: string;
}

export const enviarNotificacao = async (request: IEnviarNotificacaoRequest): Promise<number | null> => {
  try {
    const { data } = await api.post<{ idNotificacao: number }>("/Notificacao/EnviarNotificacao", request);
    return data?.idNotificacao || null;
  } catch (error: any) {
    getErrorsByApi(error, "Erro ao enviar notificação");
    return null;
  }
};

export const reenviarNotificacao = async (idNotificacao: number): Promise<boolean> => {
  try {
    const { data } = await api.post<{ sucesso: boolean }>(`/Notificacao/ReenviarNotificacao/${idNotificacao}`);
    return data?.sucesso || false;
  } catch (error: any) {
    getErrorsByApi(error, "Erro ao reenviar notificação");
    return false;
  }
};

